import AxiosClient from "../../services/axios.services";

class AreasServices {
  getAreas = (params, type) =>
    AxiosClient.get(type === 1 ? `/api/app/Formal_unidad/` : `/api/app/Funcional_unidad/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getAreasJerarquia = (params, type, isModalSearch) =>
    AxiosClient.get(isModalSearch ? "/api/app/Funcional_Unidad_Organizativa_evaluacion/" :type === 1 ? '/api/app/Formal_unidadjerarquia/' : '/api/app/Funcional_unidadjerarquia/', {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveAreas = (data, type) =>
    AxiosClient.post(type === 1 ? `/api/app/Formal_unidad/` : `/api/app/Funcional_unidad/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editAreas = (id, data, type) =>
    AxiosClient.put(type === 1 ? `/api/app/Formal_unidad/${id}/` : `/api/app/Funcional_unidad/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteAreas = (id, type) =>
    AxiosClient.delete(type === 1 ? `/api/app/Formal_unidad/${id}/` : `/api/app/Funcional_unidad/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new AreasServices();
